type SpeakerConfig = {
  enableEventAssigning: boolean
}

const getSpeakerConfig: SpeakerConfig = {
  enableEventAssigning: true,
}

export default getSpeakerConfig
